import React from 'react';

import { useOTSTranslation } from 'i18n/useOTSTranslation';
import { SanitizeMode, useSanitizedText } from 'util/sanitized';
import styles from './styles.module.scss';

export const SnowReportComments = ({ comments }: { comments: string, isFresh: boolean }) => {
  const { t } = useOTSTranslation('common');
  const cleanComments = useSanitizedText(comments, SanitizeMode.Partial);

  return (
    <div className={styles.comments}>
      <span className={styles.commentIntro}>
        {t('resort.skiReport.SnowreporterComments')}
        :
        {' '}
      </span>
      <span dangerouslySetInnerHTML={{ __html: cleanComments }} />
    </div>

  );
};
